import { CompetitionDivisionSelect } from '../../../divisions/components/competition-division-select';
import { ClubSearchSelect } from '~/pages/club/components/club-search-select';
import { useUnsavedChangesGuard } from '~/hooks/useUnsavedChangesGuard';
import { zodResolver } from '@hookform/resolvers/zod';
import { schema, Schema } from './team-form.schema';
import { Button } from '~/components/Button/Button';
import { Grid } from '~/components/Grid/Grid';
import { Input } from '~/components/Input';
import { Resolver, useForm } from 'react-hook-form';

interface Props {
  onSubmit: (data: Schema) => void;
  mode: 'create' | 'edit';
  defaultValues?: Partial<Schema>;
  competitionId: number;
  isLoading: boolean;
}

export function CompetitionTeamForm({ defaultValues, mode, competitionId, isLoading, onSubmit }: Props) {
  const { formState, register, handleSubmit, setValue, watch, trigger } = useForm<Schema>({
    defaultValues: defaultValues as Schema,
    resolver: zodResolver(schema) as unknown as Resolver<Schema>,
  });

  const { dialog } = useUnsavedChangesGuard(formState);

  return (
    <form onSubmit={handleSubmit(onSubmit)} autoComplete="off">
      <Grid>
        <Grid.Item cols={{ sm: 12, md: 6 }}>
          <Input.Group formState={formState} htmlFor="name" label="Lagnamn">
            <Input.Field type="text" {...register('name')} formState={formState} />
          </Input.Group>
        </Grid.Item>

        <Grid.Item cols={{ sm: 12, md: 6 }}>
          <Input.Group formState={formState} htmlFor="division" label="Lagtävlingsdivision">
            <CompetitionDivisionSelect
              competitionId={competitionId}
              {...register('division')}
              value={watch('division')}
              formState={formState}
              disabled={mode === 'edit'}
            />
          </Input.Group>
        </Grid.Item>
      </Grid>

      <Grid>
        <Grid.Item cols={{ sm: 12, md: 6 }}>
          <Input.Group formState={formState} htmlFor="club" label="Ansvarig förening (valfritt)">
            <ClubSearchSelect
              {...register('club')}
              placeholder="Sök förening..."
              onChange={v => {
                setValue('club', (v as [string, number]) ?? null, { shouldDirty: true });
                trigger('club');
              }}
              formState={formState}
              value={watch('club') ?? undefined}
            />
          </Input.Group>
        </Grid.Item>
      </Grid>

      <Button.Group align="right">
        <Button type="submit" isLoading={isLoading}>
          {{ create: 'Skapa', edit: 'Spara' }[mode]}
        </Button>
      </Button.Group>

      {dialog}
    </form>
  );
}
